import React, { useState, useEffect } from 'react';
import {
    DataTable, TableContainer, Table, TableHead,
    TableRow, TableHeader, TableBody, TableCell, DataTableSkeleton, Pagination,
    TableExpandRow, TableExpandedRow, TableExpandHeader, Button
} from 'carbon-components-react';
import * as DashboardConstants from '../components/Dashboards/DashboardConstants'
import { SkipForwardFilled32 } from '@carbon/icons-react';
import ReactHtmlParser from 'react-html-parser';

const DataTableComponent = (props) => {
    const defaultFirstRowIndex = 0;
    const defaultCurrentPageSize = props.defaultCurrentPageSize || 5;
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(defaultFirstRowIndex);
    const [currentPage, setCurrentPage] = useState(0);
    const [TotalPages, setTotalPages] = useState(0);
    const [openedTableCells, setOpenedTableCells] = useState([]);
    const ellipsis = '<span style="color:blue">...</span>'

    useEffect(() => {
        if (props.rows.length) {
            setTotalItems(props.rows.length);
            getPaginatedRows(defaultFirstRowIndex, defaultCurrentPageSize);
        }
    }, [props.rows])

    function getPaginatedRows(param, pageSize) {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = props.rows.slice(startingIndex, startingIndex + pageSize);
        if (props.isExpandedTable && props.isExpandedTable === true) {
            setPaginatedRows(props.rows);
        }
        else setPaginatedRows(slicedRows);
    }

    function displayCell(cell) {
        let currentHeader = props.headers.filter(function (header) { return header.key === cell.info.header });
        if (!currentHeader[0].optional) {
            return true;
        } else {
            return false;
        }
    }

    const showFullCell = (cellId) => {
        setOpenedTableCells(openedTableCells => [...openedTableCells, cellId]);
    }

    return (
        props.loading ?
            <DataTableSkeleton
                columnCount={5}
                rowCount={5}
            />
            :
            props.rows.length && !props.loading ?
                <div className="table-container">
                    <DataTable rows={paginatedRows} headers={props.headers} isSortable={props.isSortingAllowed} render={({
                        rows,
                        headers,
                        getHeaderProps,
                        getRowProps,
                        getTableProps }) => (
                        <TableContainer>
                            <Table {...getTableProps()} size={props.size}>
                                <TableHead>
                                    <TableRow>
                                        {props.isExpandable && <TableExpandHeader />}
                                        {headers.map(header => (
                                            header.header && !header.optional && <TableHeader {...getHeaderProps({ header })}>
                                                {header.header}
                                            </TableHeader>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, i) => (
                                        props.isExpandable ?
                                            <React.Fragment key={row.id}>
                                                <TableExpandRow {...getRowProps({ row })} onClick={() => props.onRowExpand(row)}>
                                                    {row.cells.map(cell => (
                                                        displayCell(cell) ?
                                                            <TableCell className={(cell.value && cell.value.length > 50 && !openedTableCells.includes(cell.id) ? 'show-cursor' : '')} key={cell.id} onClick={() => showFullCell(cell.id)}>
                                                                {openedTableCells.includes(cell.id) ? cell.value : cell.value && cell.value.length > 50 ? cell.value.substr(0, 50) : cell.value}
                                                                {cell.value && cell.value.length > 50 && !openedTableCells.includes(cell.id) ? ReactHtmlParser(ellipsis) : ''}
                                                            </TableCell>
                                                            :
                                                            ''
                                                    ))}
                                                </TableExpandRow>
                                                {row.isExpanded && (
                                                    <TableExpandedRow colSpan={props.headers.length + 1}>
                                                        <div className="insight-expanded-item">
                                                            <div className="expanded-table-title carbon-display-Semibold-14">{props.expandedTableTitle}</div>
                                                            {row.cells[4].value.map((error) => {
                                                                return <div className='value'>{error}</div>
                                                            })}
                                                        </div>
                                                    </TableExpandedRow>
                                                )}
                                            </React.Fragment>
                                            :
                                            <TableRow key={"row" + i} {...getRowProps({ row })}>
                                                {row.cells.map(cell => (
                                                    displayCell(cell) ?
                                                        <TableCell key={"cell" + i}>
                                                            {cell.value || '-'}
                                                        </TableCell>
                                                        :
                                                        ''
                                                ))}
                                            </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>)}
                    />
                    {props.showPagination && props.rows.length > (props.tablePaginationLimit || 5) &&
                        <div className='pagination-container'>
                            <Pagination
                                totalItems={totalItems}
                                backwardText={DashboardConstants.Previouspage}
                                forwardText={DashboardConstants.NextPage}
                                pageSize={props.defaultCurrentPageSize || 5}
                                pageSizes={[7, 14, 21, 28]}
                                itemsPerPageText={props.itemsPerPageText ? props.itemsPerPageText : DashboardConstants.Itemspage}
                                onChange={({ page, pageSize }) => {
                                    let newFirstRowIndex = pageSize * (page - 1);
                                    setFirstRowIndex(newFirstRowIndex)
                                    getPaginatedRows(newFirstRowIndex, pageSize);
                                }}
                                pageRangeText={(current, total) => {
                                    props.getPages && setTotalPages(total);
                                    props.getPages && setCurrentPage(current);
                                    props.getPages && props.getPages(total, current);
                                    return `of ${total} pages`
                                }}
                                itemRangeText={(min, max, total) => props.paginateRecords && props.paginateRecords === true && total !== props.totalItems ? `${min}–${max} of Top ${total} from ${props.totalItems} items` : `${min}–${max} of ${total} items`}
                            />
                            {props.paginateRecords && props.totalItems && totalItems < props.totalItems && TotalPages === currentPage ?
                                <div className='fastforward'><Button renderIcon={SkipForwardFilled32} hasIconOnly onClick={() => props.handleNextClick()} kind="ghost" iconDescription="Load more records"
                                /></div> : null}
                        </div>
                    }
                </div>
                :
                <div className="message">{DashboardConstants.NoDataAvailable}</div>
    );
}

export default DataTableComponent
